import { createContext, useContext } from "react";
import { UseDuckSidebarResize } from "duck/ui/chat/hooks";

export const DuckSidebarResizeContext = createContext<
  UseDuckSidebarResize | undefined
>(undefined);

export const useDuckSidebarResizeContext = () => {
  const context = useContext(DuckSidebarResizeContext);
  if (!context) {
    throw new Error(
      "useDuckSidebarResizeContext must be used within a DuckSidebarResizeProvider"
    );
  }

  return context;
};
